import { FormController } from '../classes/form-controller';
const axios = require('axios');

export default class extends FormController {
	static targets = ['form', 'input', 'resultContainer', 'noResultsContainer', 'noResultsItems', 'resultsContainer', 'loading'];

	connect() {
		// Call connect from FormController
		super.connect();
	}

	/**
	 * Submit contact form.
	 *
	 * @param {Event} e
	 */
	submit(e) {
		e.preventDefault();
		const formData = new FormData(this.formTarget);

		this.loadingTarget.setAttribute('data-group-loading', 'true');

		axios
			.post(supersage.ajaxURL, formData)
			.then((response) => {
				if (response.data.status == 'error') {
					this.displayErrors(response.data.errors);
				}

				if (response.data.status == 'success') {
                    this.resultsContainerTarget.innerHTML = '';
                    this.displayResults(response.data.results);
				}

                this.loadingTarget.removeAttribute('data-group-loading');
			})
			.catch((error) => {
				console.log(error);
				this.loadingTarget.removeAttribute('data-group-loading');
			});
	}

    displayResults(results) {
		// Display results
		if (results.length > 0) {
			this.noResultsContainerTarget.classList.add('hidden');
			this.resultsContainerTarget.classList.remove('hidden');

			results.forEach((result) => {
				this.resultsContainerTarget.insertAdjacentHTML('beforeend', result);
			});

			// Display no results
		} else {
			this.noResultsContainerTarget.classList.remove('hidden');
			this.resultsContainerTarget.classList.add('hidden');

			if(results.length > 0) {
				results.forEach((result) => {
					this.noResultsItemsTarget.insertAdjacentHTML('beforeend', result);
				});
			}
		}
	}
}
